<template>
  <div id="configuratorTableWood" class="mobile">
    <div class="selectorWrapper">
      <div>
        <v-btn v-bind:class="{hidden : !getPlanks.used[0].downArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlank(0, 'down')" >
          <img src="./../../public/icons/arrowDown.svg" class="leftArrow" height="20px"/>
        </v-btn>
      </div>
      <!-- <div :style="{height: svgHeight}" @click="changePlank(0, 'down')" v-bind:class="{hidden : !getPlanks.used[0].downArrow}">
        <v-icon v-if="getPlanks.choosePlanks" color="var(--mainColor)" class="mobileRight" >mdi-chevron-left</v-icon>
      </div> -->
      <div style="height:1px;"></div>
      <div>
        <v-btn v-bind:class="{hidden : !getPlanks.used[1].downArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlank(1, 'down')" >
          <img src="./../../public/icons/arrowDown.svg" class="leftArrow" height="20px"/>
        </v-btn>
      </div>
      <!-- <div :style="{height: svgHeight}" @click="changePlank(1, 'down')" v-bind:class="{hidden : !getPlanks.used[1].downArrow}">
        <v-icon v-if="getPlanks.choosePlanks" color="var(--mainColor)" class="mobileRight" >mdi-chevron-left</v-icon>
      </div> -->
      <div v-if="getPlanks.numberOfPlanks == 3 || getPlanks.numberOfPlanks == 4" style="height:1px;"></div>
      <div v-if="getPlanks.numberOfPlanks == 3 || getPlanks.numberOfPlanks == 4">
        <v-btn v-bind:class="{hidden : !getPlanks.used[2].downArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlank(2, 'down')" >
          <img src="./../../public/icons/arrowDown.svg" class="leftArrow" height="20px"/>
        </v-btn>
      </div>
      <!-- <div :style="{height: svgHeight}" v-if="getPlanks.numberOfPlanks == 3 || getPlanks.numberOfPlanks == 4"  v-bind:class="{hidden : !getPlanks.used[2].downArrow}" @click="changePlank(2, 'down')" >
        <v-icon v-if="getPlanks.choosePlanks" color="var(--mainColor)" class="mobileRight" >mdi-chevron-left</v-icon>
      </div> -->
      <div v-if="getPlanks.numberOfPlanks == 4" style="height:1px;"></div>
      <div v-if="getPlanks.numberOfPlanks == 4" @click="changePlank(3, 'down')">
        <v-btn v-bind:class="{hidden : !getPlanks.used[3].downArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlank(3, 'down')" >
          <img src="./../../public/icons/arrowDown.svg" class="leftArrow" height="20px"/>
        </v-btn>
      </div>
      <!-- <div :style="{height: svgHeight}" v-if="getPlanks.numberOfPlanks == 4" @click="changePlank(3, 'down')"  v-bind:class="{hidden : !getPlanks.used[3].downArrow}">
        <v-icon v-if="getPlanks.choosePlanks" color="var(--mainColor)" class="mobileRight" >mdi-chevron-left</v-icon>
      </div> -->
    </div>
    <div :style="{'width':divSvgWidth, 'height':divSvgHeight, 'padding-left':'calc((100% - ' + divSvgWidth + ')/2)' }" id="svgContainer" >


      <svg width="100%" :height="svgHeight">
        <pattern id="img1" patternUnits="userSpaceOnUse" width="100%" height="100%">
          <image v-bind="{'xlink:href' : require('./../../public/img/tablePlankPictures/' + getPlanks.availablePlanks[getPlanks.used[0].index] )}"  :width="plankImageWidth" :height="plankImageHeight" />
        </pattern>
        <rect height="100%" width="100%" fill="url(#img1)" xmlns="http://www.w3.org/2000/svg"/>
      </svg>

      <div v-if="tableTopSingle" style="height:1px;"></div>

      <svg width="100%" :height="svgHeight">
        <pattern id="img2" patternUnits="userSpaceOnUse" width="100%" height="100%">
          <image v-bind="{'xlink:href' : require('./../../public/img/tablePlankPictures/' + getPlanks.availablePlanks[getPlanks.used[1].index] )}"  :width="plankImageWidth" :height="plankImageHeight" />
        </pattern>
        <rect height="100%" width="100%" fill="url(#img2)" xmlns="http://www.w3.org/2000/svg"/>
      </svg>

      <div v-if="tableTopSingle && (getPlanks.numberOfPlanks == 3 || getPlanks.numberOfPlanks == 4)" style="height:1px;"></div>

      <svg v-if="getPlanks.numberOfPlanks == 3 || getPlanks.numberOfPlanks == 4" width="100%" :height="svgHeight">
        <pattern id="img3" patternUnits="userSpaceOnUse" width="100%" height="100%">
          <image v-bind="{'xlink:href' : require('./../../public/img/tablePlankPictures/' + getPlanks.availablePlanks[getPlanks.used[2].index] )}"  :width="plankImageWidth" :height="plankImageHeight" />
        </pattern>
        <rect height="100%" width="100%" fill="url(#img3)" xmlns="http://www.w3.org/2000/svg"/>
      </svg>

      <div v-if="tableTopSingle && getPlanks.numberOfPlanks == 4" style="height:1px;"></div>

      <svg v-if="getPlanks.numberOfPlanks == 4" width="100%" :height="svgHeight">
        <pattern id="img4" patternUnits="userSpaceOnUse" width="100%" height="100%">
          <image v-bind="{'xlink:href' : require('./../../public/img/tablePlankPictures/' + getPlanks.availablePlanks[getPlanks.used[3].index] )}"  :width="plankImageWidth" :height="plankImageHeight" />
        </pattern>
        <rect height="100%" width="100%" fill="url(#img4)" xmlns="http://www.w3.org/2000/svg"/>
      </svg>
    </div>


    <div class="selectorWrapper">
      <!-- <div :style="{height: svgHeight}" @click="changePlank(0, 'up')" v-bind:class="{hidden : !getPlanks.used[0].upArrow}">
        <v-icon v-if="getPlanks.choosePlanks" color="var(--mainColor)" class="mobileRight">mdi-chevron-right</v-icon>
      </div> -->
      <div>
        <v-btn v-bind:class="{hidden : !getPlanks.used[0].upArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlank(0, 'up')" >
          <img src="./../../public/icons/arrowDown.svg" class="rightArrow" height="20px"/>
        </v-btn>
      </div>
      <div style="height:1px;"></div>
      <!-- <div :style="{height: svgHeight}" @click="changePlank(1, 'up')" v-bind:class="{hidden : !getPlanks.used[1].upArrow}">
        <v-icon v-if="getPlanks.choosePlanks" color="var(--mainColor)" class="mobileRight">mdi-chevron-right</v-icon>
      </div> -->
      <div>
        <v-btn v-bind:class="{hidden : !getPlanks.used[1].upArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlank(1, 'up')" >
          <img src="./../../public/icons/arrowDown.svg" class="rightArrow" height="20px"/>
        </v-btn>
      </div>
      <div v-if="getPlanks.numberOfPlanks == 3 || getPlanks.numberOfPlanks == 4" style="height:1px;"></div>
      <!-- <div :style="{height: svgHeight}" v-if="getPlanks.numberOfPlanks == 3 || getPlanks.numberOfPlanks == 4"  v-bind:class="{hidden : !getPlanks.used[2].upArrow}" @click="changePlank(2, 'up')" >
        <v-icon v-if="getPlanks.choosePlanks" color="var(--mainColor)" class="mobileRight">mdi-chevron-right</v-icon>
      </div> -->
      <div v-if="getPlanks.numberOfPlanks == 3 || getPlanks.numberOfPlanks == 4">
        <v-btn v-bind:class="{hidden : !getPlanks.used[2].upArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlank(2, 'up')" >
          <img src="./../../public/icons/arrowDown.svg" class="rightArrow" height="20px"/>
        </v-btn>
      </div>
      <div v-if="getPlanks.numberOfPlanks == 4" style="height:1px;"></div>
      <!-- <div :style="{height: svgHeight}" v-if="getPlanks.numberOfPlanks == 4"  v-bind:class="{hidden : !getPlanks.used[3].upArrow}" @click="changePlank(3, 'up')" >
        <v-icon v-if="getPlanks.choosePlanks" color="var(--mainColor)" class="mobileRight">mdi-chevron-right</v-icon>
      </div> -->
      <div v-if="getPlanks.numberOfPlanks == 4">
        <v-btn v-bind:class="{hidden : !getPlanks.used[3].upArrow}" fab depressed small dark color="var(--accentColor)" @click="changePlank(3, 'up')" >
          <img src="./../../public/icons/arrowDown.svg" class="rightArrow" height="20px"/>
        </v-btn>
      </div>
    </div>
    <div v-if="!mobile" style="height: 30px;"></div>
  </div>
</template>

<script>


export default {
  name: 'configuratorTableWood',
    props: ['mobile'],
  data() {
    return{
      choosePlanksCheckboxText: "Bohlen selbst aussuchen",
      choosePlanks: false,
    };
  },
  components: {  },
  computed: {
    widthOfParent(){
      // var returnWidth = window.innerWidth
      // if(!this.vertical){
      //   return returnWidth - 200
      // } else {
      //   return returnWidth
      // }
      if(this.mobile){
        return window.innerWidth
      } else { return 400 }
    },
    getText() {return this.$store.getters.getText.tableConfigurator.configurator.chooseWood.abovePlanks},
    widthOfWoodView(){return this.widthOfParent - 80},

    getDimensions() {return this.$store.getters.getTableConfig.dimensions;},

    // divSvgHeight() {return this.widthOfWoodView/220 * this.getDimensions.width + 'px'},
    divSvgHeight() {return this.divSvgWidth * this.getDimensions.width / this.getDimensions.length + 'px'},
    // divSvgWidth() {return this.getDimensions.length / 220 * 100 + '%'},
    divSvgWidth() {return this.getDimensions.length / 220 * this.widthOfWoodView + 'px'},

    getPlanks() {return this.$store.getters.getTableConfig.planks;},

    tableTopSingle() {
      if(
        this.$store.getters.getTableConfig.tableTop == "solid"
      ){
        return false
      } else {
        return true
      }
    },

    spaceBetweenPlanks() {
      if(this.tableTopSingle){
        return 0
      } else {
        return 1
      }
    },

    plankImageWidth() {return this.widthOfWoodView + 'px'},
    plankImageHeight() {return this.widthOfWoodView * 0.129 + 'px'},
    svgHeight(){return this.widthOfWoodView/220 * this.getDimensions.width / this.getPlanks.numberOfPlanks - this.spaceBetweenPlanks + 'px'},
  },
  mounted () {
    this.choosePlanks = this.getPlanks.choosePlanks
  },
  watch: {
  },
  methods: {
    changePlank(index, direction){
      var payload= {direction: direction, position: index}
      this.$store.dispatch("changeTableConfig", {change: 'changePlank', value: payload});
      this.$gtag.event('setWoodChangePlank', {
        'event_category': 'tableConfigurator',
        'value': 1
      })
    }
  },
 }
</script>

<style scoped>
  .hidden{
    visibility: hidden;
  }
  .desktopLeft{
    position: relative;
    right: -10px;
    top: 10px;
    background-color: var(--accentColor);
    border-radius: 50%;
  }
  .desktopRight{
    position: relative;
    left: -10px;
    top: 10px;
    background-color: var(--accentColor);
    border-radius: 50%;
  }
  .mobileLeft, .mobileRight{
    position: relative;
    top: 5px;
    background-color: var(--accentColor);
    border-radius: 50%;
  }
  /* .mobile{
    position: relative;
    top: 100px;
  } */
  .selectorWrapper{
    width: 100%;
    height: 100%;
  }
  #svgContainer{
    box-sizing: content-box;
    font-size: 0 !important;
    line-height: 0 !important;
  }
  #configuratorTableWood{
    display: grid;
    position: relative;
    grid-template-columns: 40px 1fr 40px;
    width: 100%;
    }
  img {
    max-width:100%;
    max-height:100%;
  }
  #img-overlay {
    padding: 50px 100px;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      /* z-index:100; */
      /* background-color: rgba(206, 150, 58,0.85); */
      background-color: #F2CFC4CC;
    }
    .rightArrow{
      -webkit-transform: rotate(270deg);
      -moz-transform: rotate(270deg);
      -o-transform: rotate(270deg);
      -ms-transform: rotate(270deg);
      transform: rotate(270deg);
    }
    .leftArrow{
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -o-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);
    }
</style>
